module.exports = __webpack_public_path__ + "static/media/polycarb.999fc134.webp";